var _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgAnimatedPhone(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_2984_13886)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M8.52216 11.5526C7.52084 10.5512 6.73019 9.41905 6.15019 8.21103C6.1003 8.10712 6.07536 8.05517 6.05619 7.98942C5.98809 7.7558 6.03701 7.46891 6.17868 7.27106C6.21855 7.21538 6.26618 7.16775 6.36144 7.07249C6.65278 6.78115 6.79845 6.63548 6.89369 6.489C7.25285 5.93659 7.25285 5.22444 6.89369 4.67203C6.79845 4.52555 6.65278 4.37988 6.36144 4.08854L6.19905 3.92615C5.75618 3.48328 5.53475 3.26185 5.29693 3.14156C4.82396 2.90234 4.26541 2.90234 3.79244 3.14156C3.55462 3.26185 3.33319 3.48328 2.89032 3.92615L2.75896 4.05751C2.3176 4.49887 2.09693 4.71954 1.92839 5.01957C1.74137 5.35249 1.6069 5.86957 1.60804 6.25142C1.60906 6.59554 1.67582 6.83073 1.80932 7.3011C2.5268 9.82893 3.88053 12.2142 5.87051 14.2042C7.86049 16.1942 10.2458 17.5479 12.7736 18.2654C13.244 18.3989 13.4792 18.4657 13.8233 18.4667C14.2052 18.4678 14.7222 18.3334 15.0552 18.1463C15.3552 17.9778 15.5759 17.7571 16.0172 17.3158L16.1486 17.1844C16.5914 16.7415 16.8129 16.5201 16.9332 16.2823C17.1724 15.8093 17.1724 15.2508 16.9332 14.7778C16.8129 14.54 16.5914 14.3185 16.1486 13.8757L15.9862 13.7133C15.6948 13.4219 15.5492 13.2763 15.4027 13.181C14.8503 12.8219 14.1381 12.8219 13.5857 13.181C13.4392 13.2763 13.2936 13.4219 13.0022 13.7133C12.907 13.8085 12.8593 13.8562 12.8037 13.896C12.6058 14.0377 12.3189 14.0866 12.0853 14.0185C12.0196 13.9994 11.9676 13.9744 11.8637 13.9245C10.6557 13.3445 9.52347 12.5539 8.52216 11.5526Z",
    stroke: "#255B8F",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M11.708 5.00001C12.522 5.15881 13.27 5.55689 13.8564 6.14328C14.4428 6.72968 14.8409 7.47773 14.9997 8.29167",
    stroke: "#255B8F",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    opacity: 0
  }, /*#__PURE__*/React.createElement("animate", {
    attributeName: "opacity",
    values: "1;0;1;0;1;0;0",
    dur: "3s",
    repeatCount: "indefinite",
    begin: "0s"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M11.708 3.33334C12.8605 3.52121 13.9375 4.02845 14.8284 4.79772C15.7193 5.567 16.3906 6.57133 16.7747 7.70834",
    stroke: "#255B8F",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    opacity: 0
  }, /*#__PURE__*/React.createElement("animate", {
    attributeName: "opacity",
    values: "0;0;1;0;1;0;0",
    dur: "3s",
    repeatCount: "indefinite",
    begin: "0s"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M11.708 1.66667C13.3991 1.85454 14.976 2.61182 16.1799 3.81418C17.3838 5.01654 18.143 6.59251 18.333 8.28334",
    stroke: "#255B8F",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    opacity: 0
  }, /*#__PURE__*/React.createElement("animate", {
    attributeName: "opacity",
    values: "0;0;1;1;1;0;0",
    dur: "3s",
    repeatCount: "indefinite",
    begin: "0s"
  })))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_2984_13886"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 20,
    height: 20,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAnimatedPhone);
export default __webpack_public_path__ + "static/media/animated-phone.cbb45111c1b682312bb1147ecbe628fb.svg";
export { ForwardRef as ReactComponent };